import { Flex, Heading, Text } from 'rebass'

import Button from '../components/button'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import IconButton from '@material-ui/core/IconButton'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import React from 'react'
import { Trans } from '@lingui/macro'
import theme from '../utils/theme'
import typography from '../utils/typography'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import { withStyles } from '@material-ui/core/styles'

const DialogTitle = withStyles(theme => {
  return {
    root: {
      margin: 0,
      padding: theme.spacing.unit * 3,
    },
  }
})(MuiDialogTitle)

class CV extends React.Component {
  state = {
    open: false,
  }

  toggleOpen = () => {
    this.setState({ open: !this.state.open })
  }

  render() {
    const { fullScreen } = this.props

    return (
      <>
        <Button variant="outlined" color="primary" onClick={this.toggleOpen}>
          <Trans>Životopis</Trans>
        </Button>
        <Dialog
          fullScreen={fullScreen}
          onClose={this.toggleOpen}
          open={this.state.open}
          scroll="body"
        >
          <DialogTitle>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading as="h1" fontSize={[4, 5]} fontWeight="normal">
                <Trans>MDDr. Ondřej Klika</Trans>
              </Heading>
              <IconButton onClick={this.toggleOpen}>
                <FontAwesomeIcon
                  icon="times"
                  style={{ width: 24, height: 24 }}
                />
              </IconButton>
            </Flex>
          </DialogTitle>
          <DialogContent>
            <Heading as="h2" my={2}>
              <Trans>Praxe</Trans>
            </Heading>
            <Heading as="h3" my={2} fontWeight="normal">
              <Trans>od 2014</Trans>
            </Heading>
            <ul style={{ color: theme.colors.primary }}>
              <li>
                <Text color={typography.options.bodyColor}>
                  Brandeis Clinic, <Trans>garant zubního oddělení</Trans>
                  <br />
                  <em>
                    <Trans>Praha</Trans>
                  </em>
                </Text>
              </li>
            </ul>
            <Heading as="h3" my={2} fontWeight="normal">
              2013 - 2014
            </Heading>
            <ul style={{ color: theme.colors.primary }}>
              <li>
                <Text color={typography.options.bodyColor}>
                  <Trans>Dům zubní péče o dítě a rodinu</Trans>
                  <br />
                  <em>
                    <Trans>Praha</Trans>
                  </em>
                </Text>
              </li>
            </ul>
            <Heading as="h2" my={2}>
              <Trans>Semináře a sympozia</Trans>
            </Heading>
            <Heading as="h3" my={2} fontWeight="normal">
              2015
            </Heading>
            <ul style={{ color: theme.colors.primary }}>
              <li>
                <Text color={typography.options.bodyColor}>
                  Competence in Esthetics 2015, The seventh joint international
                  symposium on dental esthetics
                  <br />
                  <em>Vienna, Austria</em>
                </Text>
              </li>
              <li>
                <Text color={typography.options.bodyColor}>
                  <Trans>Neúspěchy v estetické stomatologii</Trans>
                  <br />
                  <em>
                    Oliver Brix, <Trans>Praha</Trans>
                  </em>
                </Text>
              </li>
            </ul>
            <Heading as="h3" my={2} fontWeight="normal">
              2013
            </Heading>
            <ul style={{ color: theme.colors.primary }}>
              <li>
                <Text color={typography.options.bodyColor}>
                  <Trans>Adhesivní můstky přímo, nepřímo</Trans>
                  <br />
                  <em>
                    <Trans>MUDr.</Trans> Hajný, Dentamed <Trans>Praha</Trans>
                  </em>
                </Text>
              </li>
              <li>
                <Text color={typography.options.bodyColor}>
                  CAD/CAM IPS e.max
                  <br />
                  <em>
                    <Trans>MUDr.</Trans> Hajný, Grübel, Barceló{' '}
                    <Trans>Praha</Trans>
                  </em>
                </Text>
              </li>
              <li>
                <Text color={typography.options.bodyColor}>
                  <Trans>Estetika pomocí fazet</Trans>
                  <br />
                  <em>
                    <Trans>MUDr.</Trans> Hajný, Imperial Ostrava
                  </em>
                </Text>
              </li>
              <li>
                <Text color={typography.options.bodyColor}>
                  <Trans>Estetická stomatologie v praxi</Trans>
                  <br />
                  <em>
                    <Trans>MUDr.</Trans> Hajný, Dentamed <Trans>Praha</Trans>
                  </em>
                </Text>
              </li>
              <li>
                <Text color={typography.options.bodyColor}>
                  CURAPROX Oral health prophylaxis
                  <br />
                  <em>
                    Praia da Areia Branca, <Trans>Portugalsko</Trans>
                  </em>
                </Text>
              </li>
              <li>
                <Text color={typography.options.bodyColor}>
                  <Trans>Praktický kurz fixní protetika</Trans>
                  <br />
                  <em>
                    Schaan, <Trans>Lichtenštejnsko</Trans>
                  </em>
                </Text>
              </li>
              <li>
                <Text color={typography.options.bodyColor}>
                  <Trans>
                    Endodoncie, reendodoncie, postendodontické ošetření
                  </Trans>
                  <br />
                  <em>
                    <Trans>MUDr.</Trans> Černý, Olomouc
                  </em>
                </Text>
              </li>
              <li>
                <Text color={typography.options.bodyColor}>
                  <Trans>HDVI - Fixní protetika</Trans>
                  <br />
                  <em>
                    <Trans>MUDr.</Trans> Nožička, Hradec Králové
                  </em>
                </Text>
              </li>
            </ul>
            <Heading as="h3" my={2} fontWeight="normal">
              2012
            </Heading>
            <ul style={{ color: theme.colors.primary }}>
              <li>
                <Text color={typography.options.bodyColor}>
                  <Trans>Víme jak na zubní kaz</Trans>
                  <br />
                  <em>ARAK, Olomouc</em>
                </Text>
              </li>
              <li>
                <Text color={typography.options.bodyColor}>
                  Tissue management, <Trans>kofferdam</Trans>
                  <br />
                  <em>
                    <Trans>klinika LFUP</Trans>, Olomouc
                  </em>
                </Text>
              </li>
            </ul>
            <Heading as="h3" my={2} fontWeight="normal">
              2011
            </Heading>
            <ul style={{ color: theme.colors.primary }}>
              <li>
                <Text color={typography.options.bodyColor}>
                  <Trans>Víme jak na zubní kaz</Trans>
                  <br />
                  <em>ARAK, Olomouc</em>
                </Text>
              </li>
            </ul>
          </DialogContent>
        </Dialog>
      </>
    )
  }
}

export default withMobileDialog()(CV)
